import React from 'react';
import { Route, Switch } from 'react-router-dom';
import EditUser from '../../../UserEdit/index';

export default () => (
  <Switch>
    <Route exact path="/editUser" component={EditUser} />
  </Switch>
);
